import * as React from 'react';
import { Component, BranchSelector, BranchMerge, SearchWrapper, LoopEnd } from '../../components';
import { ACTIVE_ELEMENT_TYPES, COMPONENT_MENU, COMPONENT_MENU_SINGLE_BRANCH } from '../../constants';
import {
	EComponentTypes, ISearchLocation, clone, IComponentMethods, IComponent, IElementDictionary, IComponentDictionary, IComponentType, IComponentTypeDictionary,
	IUiElement, IUiBranch, ComponentHelper, PropertyHelper, QueryBuilderHelper, EModalType
} from '../../helpers';
import { Button, ButtonType, ContextualMenu, DirectionalHint, IContextualMenuItem, IDropdownOption, TextField } from 'office-ui-fabric-react';
import Collapsible from 'react-collapsible';
import OutsideClickHandler from 'react-outside-click-handler';

interface IProps extends IComponentMethods {
	term: string;
	suggestions: IComponentTypeDictionary;
	components: IComponentDictionary;
	StartId: string;
	branchId: string;
	searchLocation: ISearchLocation;
	parentComponentId: string;
	previousOutputBlocks?: any;
	addBranchOnly?: () => void;
	deleteBranch?: (index: number, componentId?: string) => void;
	toggleNewComponentDialog?: (componentType?: string) => void;
	updateComponentName?: (name: string, value: string, componentId: string) => void;
	addNewLayoutPanel?: (componentId: string) => void;
}
import store from '../../store/store';
import DecisionConfigContainer from '../../containers/decision-config';
import types from '../../store/types';
import ReactDOM = require('react-dom');
import { CollapseContent } from './collapse-content';

export class ComponentList<T extends IProps> extends React.Component<T, any> {

	constructor(props) {
		super(props);
		this.state = {
			showMenu: false,
			showMenuIndex: null,
			editComponentId: null,
			editIndex: null,
			showCollapsibleContent: false
		};
		this.changeShowMenu = this.changeShowMenu.bind(this);
		this.changeEditComponentId = this.changeEditComponentId.bind(this);
		this.changeEditIndex = this.changeEditIndex.bind(this);
	}


	// Toggle hamburger menu and set index to the active decision branch's index
	changeShowMenu(showMenuVal: boolean, showMenuIndexVal: number) {
		this.setState({
			showMenu: !showMenuVal,
			showMenuIndex: showMenuIndexVal
		});
	}
	changeEditComponentId(val: string, branchIndex?) {
		if (val && branchIndex >= 0) {
			store.dispatch({
				type: types.SET_BRANCH_EDIT_INDEX,
				branchIndex: branchIndex
			});

		}
		// store.dispatch({
		// 	type: types.SET_BRANCH_EDIT_INDEX,
		// 	branchIndex: 0
		// });
		this.setState({
			editComponentId: val
		});
	}
	changeEditIndex(val: number) {
		if (val === null) {

		}
		this.setState({
			editIndex: val
		});
	}

	// Save edited branch
	saveEditedBranch = (val?: number) => {

		store.dispatch({
			type: types.SAVE_EDITED_BRANCH
		});

		let state = store.getState().modalState.decisionConfig;

		if (QueryBuilderHelper.canSaveQueryEditor()) {

			// if (QueryBuilderHelper.hasOpenQueryEditor()) {
			//     QueryBuilderHelper.goToFirstOpenQueryEditor();
			// }
			// else {
			//find branches that have been removed, and remove all components associated with those branches
			let newStateBranchComponents = {};
			for (let i = 0; i < state.decision.Branches.length; i++) {
				if (state.decision.Branches[i].NextComponent && state.decision.Branches[i].NextComponent.ComponentId) {
					newStateBranchComponents[state.decision.Branches[i].NextComponent.ComponentId] = true;
				}
			}

			let components = store.getState().processState.components;

			let removedBranchComponents: string[] = components[state.componentId].Decision.Branches
				.filter(c => c.NextComponent && c.NextComponent.ComponentId && !(newStateBranchComponents[c.NextComponent.ComponentId]))
				.map(c => c.NextComponent.ComponentId);

			for (let i = 0; i < removedBranchComponents.length; i++) {

				store.dispatch({
					type: types.DELETE_COMPONENT_CHAIN,
					componentId: removedBranchComponents[i],
					components: components
				});

			}

			// Save the decision
			store.dispatch({
				type: types.UPDATE_DECISION,
				componentId: state.componentId,
				decision: state.decision
			});

			if (removedBranchComponents.length) {
				store.dispatch({
					type: types.SET_ACTIVE_COMPONENTS,
					components: store.getState().processState.components
				});
			}

			store.dispatch({ type: types.TOGGLE_DIALOG, openModal: EModalType.None });
			this.changeEditIndex(null);
			// }

		}
		else {
			QueryBuilderHelper.goToFirstQueryEditorError();
		}

	}

	hasChildBranch: boolean = false;

	suggesionHtml = (type: IComponentType): JSX.Element => {

		let componentIcon: string = ComponentHelper.getComponentIcon(type);
		let icon: JSX.Element = <span className={"suggestion-icon custom-bg-" + type.Name}>
			<i className={'ms-Icon ms-Icon--' + componentIcon} aria-hidden="true" />
		</span>;

		return (
			<div>
				{icon}
				{type.Name}
			</div>
		);

	}

	getSuggestionsHtml = (suggestions: IComponentTypeDictionary): IElementDictionary => {

		let elements: IElementDictionary = {};

		for (let typeId in suggestions) {
			elements[typeId] = this.suggesionHtml(suggestions[typeId]);
		}

		return elements;

	}

	setActiveBranch = (index, element) => {
		let nextComponentId = element.componentId + "_" + index + "_ADD";
		this.props.setNextComponentId(
			element.elementId,
			element.componentId,
			nextComponentId,
			element.type
		);
	}


	isConnectionInvalid = (componentId: string, passedSubmissionComponent: boolean): boolean => {

		let { components } = this.props;

		let component = components[componentId];

		if (!component.NextComponent || !component.NextComponent.ComponentId) {
			return false;
		}

		let nextComponent = components[component.NextComponent.ComponentId];

		let nextType: EComponentTypes = (nextComponent) ? nextComponent.ComponentType.ComponentTypeId : null;

		/**
		 * after a Submission component has been encountered, then only an action, summary or redirect may follow
		 * in the case of a Summary/Redirect component, revert to list of Allowed components determined by API
		 */
		let allowedComponents =
			passedSubmissionComponent && (component.ComponentType.ComponentTypeId !== EComponentTypes.summary && component.ComponentType.ComponentTypeId !== EComponentTypes.redirect) ?
				[EComponentTypes.action, EComponentTypes.summary, EComponentTypes.redirect] :
				component.ComponentType.Allowed;

		return !allowedComponents.filter(t => t === nextType).length;

	}
	getActiveElement = (componentId: string): IUiElement => {
		return this.props.getActiveElement(componentId);
	}

	// Set active branch index to state
	setBranchEditIndex = (branchIndex: number) => {
		store.dispatch({
			type: types.SET_BRANCH_EDIT_INDEX,
			branchIndex: branchIndex
		});
	}

	// Return the items for hamburger menu
	getMenu = (component, isStartComponent, branchIndex?): IContextualMenuItem[] => {

		let menu: IContextualMenuItem[] = clone(COMPONENT_MENU);
		// let menu: IContextualMenuItem[] = clone(COMPONENT_MENU);
		let isSubmission = component.ComponentType.ComponentTypeId === EComponentTypes.submission;

		if (!isSubmission && component.Decision && component.Decision.Branches.length === 1) {
			menu = clone(COMPONENT_MENU_SINGLE_BRANCH);
		} else if (!isSubmission && component.Decision && component.Decision.Branches.length > 1) {
			menu = clone(COMPONENT_MENU)
		}

		if (isSubmission) {
			menu[0].onClick = () => {

				// this.props.toggleSubmissionConfigDialog(component.Id);
				this.changeEditComponentId(component.Id, branchIndex);
				this.changeEditIndex(branchIndex);
				// this.changeShowMenu(true, null);
			};
		}
		else {
			menu[0].onClick = () => {
				this.changeEditComponentId(component.Id, branchIndex);
				this.changeEditIndex(branchIndex);
				// this.props.toggleSidebar(component, false);
				this.setBranchEditIndex(branchIndex);
				// this.changeShowMenu(true, null);
			};
		}

		if (isStartComponent)
			menu[1].disabled = true;
		else {
			if (menu.length > 1) {
				menu[1].onClick = () => {
					// this.props.deleteComponent(component.Id);
					// this.props.deleteComponent(component.Id);
					this.props.deleteBranch(branchIndex, component.Id);
				};
			}
		}
		// menu[0].onClick = () => {
		// 	// this.props.toggleSubmissionConfigDialog(component.Id);
		// 	this.changeEditComponentId(component.Id, branchIndex);
		// 	this.changeEditIndex(1);
		// };

		return menu;

	}

	// Poisition of the hamburger menu for component
	showContextMenu(e, text) {
		this.setState({
			showContextMenu: ((text.length > 0) ? true : false),
			selectionText: text,
			targetPoint: {
				x: e.clientX,
				y: e.clientY
			}
		})
	}

	// On every input change, update the editedbranch in the state
	nameChange = (name: string) => {
		let branchToUpdate = store.getState().modalState.decisionConfig.editedBranch;
		branchToUpdate.Name = name;
		store.dispatch({
			type: types.UPDATE_EDITED_BRANCH,
			editedBranch: branchToUpdate
		});
		// this.saveEditedBranch();

	}

	getItem = (component: IComponent, element: IUiElement, previousOutputBlocks: { [id: string]: boolean }, branchList: IUiBranch[], passedSubmissionComponent: boolean,
		branchName?: string, index?: number, isCollapsibleComponent: boolean = false, prevDecisionItems?: any[], parentDecisionID?: string, branchIndex?: number, contextMenu?: JSX.Element,
	) => {


		let {
			components, StartId, toggleSidebar, toggleMenu, updateProperty, toggleDialog, deleteComponent, setSearchLocation, parentComponentId,
			setNextComponentId, selectItem, term, suggestions, updateSuggestions, searchLocation, toggleNewComponentDialog,
			addNewLayoutPanel
		} = this.props;

		let typeId: number = component.ComponentType.ComponentTypeId;
		let branchId: string = branchList[branchList.length - 1].id;
		let inBranch: boolean = branchId && branchId !== 'root';

		let item: JSX.Element;

		if (isCollapsibleComponent) {
			item = <Component key={'c_' + component.Id + '_' + typeId + '_' + branchIndex}
				component={component}
				components={components}
				toggleSidebar={toggleSidebar}
				toggleMenu={toggleMenu}
				updateProperty={updateProperty}
				toggleDialog={toggleDialog}
				deleteComponent={deleteComponent}
				invalidConnection={this.isConnectionInvalid(component.Id, passedSubmissionComponent)}
				setSearchLocation={setSearchLocation}
				isStartComponent={component.Id === StartId && branchId === 'root' && !parentComponentId}
				branchId={branchId}
				previousOutputBlocks={previousOutputBlocks}
				setNextComponentId={setNextComponentId}
				element={element}
				inLoop={!!element.loopComponentId}
				toggleActionConfigDialog={this.props.toggleActionConfigDialog}
				toggleControlBlockLoopingDialog={this.props.toggleControlBlockLoopingDialog}
				toggleDecisionConfigDialog={this.props.toggleDecisionConfigDialog}
				toggleSubmissionConfigDialog={this.props.toggleSubmissionConfigDialog}
				toggleJourneySummaryDialog={this.props.toggleJourneySummaryDialog}
				toggleSharedJourneyConfig={this.props.toggleSharedJourneyConfig}
				toggleRedirectConfigDialog={this.props.toggleRedirectConfigDialog}
				toggleLoopConfigDialog={this.props.toggleLoopConfigDialog}
				updateComponentName={this.props.updateComponentName}

				isCollapsibleComponent={isCollapsibleComponent}
				saveEditedBranch={this.saveEditedBranch}
				changeEditComponentId={this.changeEditComponentId}
				nameChange={this.nameChange}
				deleteBranch={this.props.deleteBranch}
				decisionItems={prevDecisionItems}
				parentDecisionID={parentDecisionID}
				index={branchIndex}
				collapsibleContextMenu={contextMenu}
				toggleShowMenu={this.changeShowMenu}
				showMenu={this.state.showMenu}
				editComponentId={this.state.editComponentId}
				editIndex={this.state.editIndex}
				addNewLayoutPanel={addNewLayoutPanel}
			/>
		} else {

			switch (element.type) {

				case ACTIVE_ELEMENT_TYPES.Component:
					item = <Component key={'c_' + component.Id + '_' + typeId}
						component={component}
						components={components}
						toggleSidebar={toggleSidebar}
						toggleMenu={toggleMenu}
						updateProperty={updateProperty}
						toggleDialog={toggleDialog}
						deleteComponent={deleteComponent}
						invalidConnection={this.isConnectionInvalid(component.Id, passedSubmissionComponent)}
						setSearchLocation={setSearchLocation}
						isStartComponent={component.Id === StartId && branchId === 'root' && !parentComponentId}
						branchId={branchId}
						previousOutputBlocks={previousOutputBlocks}
						setNextComponentId={setNextComponentId}
						element={element}
						inLoop={!!element.loopComponentId}
						toggleActionConfigDialog={this.props.toggleActionConfigDialog}
						toggleControlBlockLoopingDialog={this.props.toggleControlBlockLoopingDialog}
						toggleDecisionConfigDialog={this.props.toggleDecisionConfigDialog}
						toggleSubmissionConfigDialog={this.props.toggleSubmissionConfigDialog}
						toggleJourneySummaryDialog={this.props.toggleJourneySummaryDialog}
						toggleSharedJourneyConfig={this.props.toggleSharedJourneyConfig}
						toggleRedirectConfigDialog={this.props.toggleRedirectConfigDialog}
						toggleLoopConfigDialog={this.props.toggleLoopConfigDialog}
						updateComponentName={this.props.updateComponentName}

						isCollapsibleComponent={isCollapsibleComponent}
						toggleShowMenu={this.changeShowMenu}
						showMenu={this.state.showMenu}
						addNewLayoutPanel={addNewLayoutPanel}
					/>
					break;

				case ACTIVE_ELEMENT_TYPES.LoopAdd:
				case ACTIVE_ELEMENT_TYPES.Add:
					let newSearchLocation: ISearchLocation = {
						branchId: branchId,
						loopComponentId: (!inBranch) ? element.loopComponentId : component.ParentLoopId,
						ComponentId: element.componentId,
						ComponentType: component.ComponentType
					};
					item = <SearchWrapper key={element.elementId}
						searchLocation={newSearchLocation}
						showResultsWithEmptyTerm={true}
						awaitingResults={false}
						debounceDelay={250}
						isCurrentSearchComponent={false}
						labelText={''}
						onResultClick={null}
						results={null}
						searchTerm={null}
						updateResults={null}
						passedSubmissionComponent={passedSubmissionComponent}
						setSearchLocation={setSearchLocation}
						element={element}
						search={false}
						inBranch={inBranch}
						inLoop={!!element.loopComponentId}
						setNextComponentId={this.props.setNextComponentId}
						toggleNewComponentDialog={toggleNewComponentDialog}

					/>;
					break;

				case ACTIVE_ELEMENT_TYPES.Search:
					item = <SearchWrapper key={element.elementId}
						awaitingResults={false}
						debounceDelay={250}
						isCurrentSearchComponent={true}
						labelText={''}
						onResultClick={(key, item) => selectItem(suggestions[key], passedSubmissionComponent)}
						results={this.getSuggestionsHtml(suggestions)}
						searchTerm={term}
						showResultsWithEmptyTerm={true}
						updateResults={updateSuggestions}
						passedSubmissionComponent={passedSubmissionComponent}
						element={element}
						searchLocation={searchLocation}
						setSearchLocation={setSearchLocation}
						search={true}
						inBranch={inBranch}
						inLoop={!!searchLocation.loopComponentId}
						toggleNewComponentDialog={toggleNewComponentDialog}
					/>;
					break;

				case ACTIVE_ELEMENT_TYPES.BranchSelector:
					item = <BranchSelector key={element.elementId}
						component={component}
						components={components}
						conditions={components[element.componentId].Decision.Branches}
						element={element}
						setNextComponentId={this.props.setNextComponentId}
						index={index}
						toggleDecisionConfigDialog={this.props.toggleDecisionConfigDialog}
						previousOutputBlocks={previousOutputBlocks}
					// branch={branchList[branchList.length - 1]}

					/>;
					break;


				case ACTIVE_ELEMENT_TYPES.MergeIcon:
					item = <BranchMerge key={element.elementId} branchName={branchName} />;
					break;

				case ACTIVE_ELEMENT_TYPES.LoopEnd:
					let loopComponent = components[element.loopComponentId];
					let loopTitle: string = PropertyHelper.getPropertyValue(loopComponent.Loop.Properties, "Title")
					item = <LoopEnd key={element.elementId} loopTitle={loopTitle} />;
					break;

				default:
					item = <span key={element.elementId}>Unknown UI element</span>;
					break;

			}
		}

		return item;

	}

	getChildComponents = (component: IComponent): any[] => {

		let { components, addBranchOnly, deleteBranch, toggleMenu } = this.props;
		let previousOutputBlocks = this.props.previousOutputBlocks && clone(this.props.previousOutputBlocks);
		let items: any[] = [];
		this.hasChildBranch = false;
		let element: IUiElement = typeof component !== "undefined" ? this.getActiveElement(component.Id) : null;
		let branchList: IUiBranch[] = [{ id: 'root', index: null, name: null }];

		/**
		 * this will be set to true after a submission component has been added to the list
		 * the result will be a limitation put on what components can be used afterwards
		 */
		let selectedBranchIndex: number;
		let branchName: string;
		let currentBranchLocation = [{ decisionId: '', branchId: 'root' }];
		let passedSubmissionOnBranch = {};
		var previousElementWasSummary: boolean = false;

		// Loops through all items in the activeProcess state, and renders the elements in the order specified by nextComponentId
		while (element) {
			let isComponent: boolean = element.type === "Component";

			if (isComponent)
				component = components[element.elementId];

			let typeId: number = component.ComponentType.ComponentTypeId;
			let previousElement = { ...element };
			let componentBeforeLoop = { ...component };

			// if decision starts, run until the end is found
			if (element.type === "BranchSelector") {

				// store branch name to pass the name of condition to BranchMerge
				// remove this and customize the message in the BranchMerge component for general case.
				let parts: string[] = element.nextElementId.split('_');
				let branchId: string = parts[0] + '_' + parts[1];
				let branchIndex: number = +parts[1];
				branchName = component.Decision.Branches[branchIndex].Name;
				currentBranchLocation.push({ decisionId: component.Id, branchId: branchId });
				selectedBranchIndex = branchIndex;
				branchList.push({
					id: branchId,
					index: branchIndex,
					name: component.Decision.Branches[branchIndex].Name
				});

				let branches: IDropdownOption[] = components[element.componentId].Decision.Branches.map((condition, index) => {
					return { index: index, text: condition.Name || "Condition " + index, key: index };
				});

				let decisionItems: any[] = [];
				let decisionItemsParent: any[] = [];
				let lookupElementId: IUiElement;
				let lookupComponent: IComponent = { ...component };
				let parentDecisionID: string = { ...component }.Decision.ComponentId;
				let outputBlocksBeforeChildDecision = { ...previousOutputBlocks };

				// loop through each decision
				for (let i = 0; i < branches.length + 1; i++) {
					let componenetBeforeChildDecision: IComponent;

					component = lookupComponent;

					// Add '+' icon between decision component and its branches.
					if (i === 0) {
						items.push(
							<DecisionConfigContainer addOnly={true} addBranchOnly={addBranchOnly} componentId={parentDecisionID} toggleDecisionConfigDialog={this.props.toggleDecisionConfigDialog} />
						);
					}

					if (i > 0) {
						currentBranchLocation.pop();
					}

					// If it is the last branch in the decision, pop branchlist to start a new branch for the components starting outside of this decision
					if (i === branches.length) {
						let lastBranch: IUiBranch = branchList.pop();
						branchName = lastBranch.name;
						component = components[element.componentId];
					} else {
						element = previousElement;
						decisionItems = [];
						let elementIndexInBranchSelector = 0;
						branchId = parts[0] + '_' + i.toString();
						branchIndex = i;
						branchName = lookupComponent.Decision.Branches[branchIndex].Name;
						currentBranchLocation.push({ decisionId: component.Id, branchId: branchId });
						selectedBranchIndex = branchIndex;
						branchList.pop();
						branchList.push({
							id: branchId,
							index: branchIndex,
							name: componentBeforeLoop.Decision.Branches[branchIndex].Name
						});

						//loop until the end/mergeicon is found
						while ((element.type !== "MergeIcon")) {
							lookupElementId = { ...element };
							if (elementIndexInBranchSelector === 1) {
								let nextElementId = element.componentId + "_" + i + "_ADD";
								if (this.getActiveElement(nextElementId)) {
									element = this.getActiveElement(nextElementId);
									elementIndexInBranchSelector += 1;
								}
							}
							else {
								elementIndexInBranchSelector += 1;
							}

							let isComponent: boolean = element.type === "Component";

							if (isComponent) {
								component = components[element.elementId];
								// componenetBeforeChildDecision = components[lookupElement.elementId];
							}

							let typeId: number = component.ComponentType.ComponentTypeId;
							let passpreviousOutputBlocks: boolean = !isComponent
								? false
								: typeId === EComponentTypes.decision
								|| typeId === EComponentTypes.action
								|| typeId === EComponentTypes.block
								|| typeId === EComponentTypes.loop;
							let previousComponent: IComponent = element.type === ACTIVE_ELEMENT_TYPES.MergeIcon ? components[element.componentId] : component;
							let passedSubmissionOnCurrentBranch = passedSubmissionOnBranch[currentBranchLocation[currentBranchLocation.length - 1].branchId];
							let index = i;
							let item: JSX.Element = this.getItem(previousComponent, element, passpreviousOutputBlocks ? clone(previousOutputBlocks) : null, branchList,
								passedSubmissionOnCurrentBranch, branchName, index);

							let hideItem: boolean = false;
							if (element.type === "Component" || element.type === "Add") {
								let nextComponent = component && component.NextComponent ? components[component.NextComponent.ComponentId] : null;
								if (component) {
									hideItem =
										(element.type === "Component" && component.Action && component.Action.ActionType &&
											component.Action.ActionType.NameType === 'Journey Information') ||
										(element.type === "Add" && nextComponent && nextComponent.Action && nextComponent.Action.ActionType &&
											nextComponent.Action.ActionType.NameType === 'Journey Information')
										;
								}
							}

							if (!hideItem && item) {
								decisionItems.push(item);
							}

							if (isComponent) {

								if (typeId === EComponentTypes.submission) {
									passedSubmissionOnBranch[currentBranchLocation[currentBranchLocation.length - 1].branchId] = true;
								}

								if (typeId === EComponentTypes.block || typeId === EComponentTypes.action || typeId === EComponentTypes.sharedJourney)
									previousOutputBlocks[component.Id] = true;

							}

							element = element.nextElementId === null ? null : this.getActiveElement(element.nextElementId);
							previousElementWasSummary = (isComponent && typeId === EComponentTypes.summary);

							if (element.type === "BranchSelector") {
								parts = element.nextElementId.split('_');
								branchId = parts[0] + '_' + parts[1];
								branchIndex = +parts[1];
								branchName = component.Decision.Branches[branchIndex].Name;
								currentBranchLocation.push({ decisionId: component.Id, branchId: branchId });
								branchList.push({
									id: branchId,
									index: branchIndex,
									name: component.Decision.Branches[branchIndex].Name
								});

								// get child components from nested decision
								[element, decisionItems, passedSubmissionOnBranch] = this.getDecisionItems(element, branches, previousElement, decisionItems,
									branchId, branchIndex, branchList, componentBeforeLoop, parts, component, components,
									passedSubmissionOnBranch, branchName, currentBranchLocation, previousOutputBlocks,
									previousElementWasSummary, decisionItemsParent);
							}

						}

						// Get decision component. 
						// Getting the parent decision component let us check all the necessary conditions to load hamburger menu in the branch header. 
						// This is to prevent component override since the branch header is loaded only after all the child decision branches are loaded.
						componenetBeforeChildDecision = lookupComponent;

						// Item for hamburger menu
						let menu = this.getMenu(componenetBeforeChildDecision, componenetBeforeChildDecision.Id === this.props.StartId && branchId === 'root' && !this.props.parentComponentId, i);
						let contextMenu: JSX.Element = (this.state.showMenu && this.state.showMenuIndex === i &&
							this.state.editComponentId && this.state.editComponentId === componenetBeforeChildDecision.Id)
							// && this.state.editComponentId === component.Id && this.state.editIndex === i
							&& <ContextualMenu target={'.branch-' + componenetBeforeChildDecision.Id + '_branch_' + i}
								shouldFocusOnMount={false}
								onDismiss={() => {
									this.changeShowMenu(true, i)
								}}
								directionalHint={DirectionalHint.bottomRightEdge}
								items={menu}
								isBeakVisible={true}
								beakWidth={15} />;

						// Collapsible child decision branch
						// decisionItemsParent.push(<CollapseContent
						// 	component={componenetBeforeChildDecision}
						// 	saveEditedBranch={this.saveEditedBranch}
						// 	changeEditComponentId={this.changeEditComponentId}
						// 	nameChange={this.nameChange}
						// 	deleteBranch={this.props.deleteBranch}
						// 	decisionItems={decisionItems}
						// 	parentDecisionID={parentDecisionID}
						// 	toggleDecisionConfigDialog={this.props.toggleDecisionConfigDialog}
						// 	index={i}
						// 	contextMenu={contextMenu}
						// 	toggleShowMenu={this.changeShowMenu}
						// 	showMenu={this.state.showMenu}
						// 	editComponentId={this.state.editComponentId}
						// 	editIndex={this.state.editIndex}
						// 	previousOutputBlocks={outputBlocksBeforeChildDecision}
						// />);
						let collapsibleItem: JSX.Element = this.getItem(componenetBeforeChildDecision, element, outputBlocksBeforeChildDecision, branchList,
							null, branchName, null, true, decisionItems, parentDecisionID, i, contextMenu);

						decisionItemsParent.push(collapsibleItem);
					}


				}
				items.push(
					<div className="conditions component">{decisionItemsParent}</div>
				);

			}
			if (element.type === ACTIVE_ELEMENT_TYPES.MergeIcon) {
				currentBranchLocation.pop();
			}

			let passpreviousOutputBlocks: boolean = !isComponent
				? false
				: typeId === EComponentTypes.decision
				|| typeId === EComponentTypes.action
				|| typeId === EComponentTypes.block
				|| typeId === EComponentTypes.loop;

			let previousComponent: IComponent = element.type === ACTIVE_ELEMENT_TYPES.MergeIcon ? components[element.componentId] : component;
			let passedSubmissionOnCurrentBranch = passedSubmissionOnBranch[currentBranchLocation[currentBranchLocation.length - 1].branchId];

			let item: JSX.Element = this.getItem(previousComponent, element, passpreviousOutputBlocks ? clone(previousOutputBlocks) : null, branchList,
				passedSubmissionOnCurrentBranch, branchName);

			//hide item if it is the Journey Information action Component, or if it is the add component button that comes after the first step
			let hideItem: boolean = false;
			if (element.type === "Component" || element.type === "Add") {
				let nextComponent = component && component.NextComponent ? components[component.NextComponent.ComponentId] : null;
				if (component) {
					hideItem =
						//TODO: update this to use a property that indicates that a component is a system component when that property becomes available
						(element.type === "Component" && component.Action && component.Action.ActionType &&
							component.Action.ActionType.NameType === 'Journey Information') ||
						(element.type === "Add" && nextComponent && nextComponent.Action && nextComponent.Action.ActionType &&
							nextComponent.Action.ActionType.NameType === 'Journey Information')
						;
				}
			}

			if (!hideItem && item) {
				items.push(item);
			}

			if (isComponent) {

				if (typeId === EComponentTypes.submission) {
					passedSubmissionOnBranch[currentBranchLocation[currentBranchLocation.length - 1].branchId] = true;
				}

				if (typeId === EComponentTypes.block || typeId === EComponentTypes.action || typeId === EComponentTypes.sharedJourney)
					previousOutputBlocks[component.Id] = true;

			}
			element = element.nextElementId === null ? null : this.getActiveElement(element.nextElementId);

			previousElementWasSummary = (isComponent && typeId === EComponentTypes.summary);

		}

		// console.log('state --->', store.getState());

		return items;

	}


	// // Get components from nested decision
	getDecisionItems(element, branches, previousElement, decisionItems,
		branchId, branchIndex, branchList, componentBeforeLoop, parts, component, components,
		passedSubmissionOnBranch, branchName, currentBranchLocation, previousOutputBlocks,
		previousElementWasSummary, decisionItemsParent): any {

		// initialize required variables
		let firstPrevElement = { ...element };
		let prevElement = { ...element };
		let prevComponent = { ...component };
		let prevComponents = { ...components };
		let prevBranchIndex = { ...branchIndex };
		let prevDecisionItems: any[] = [];
		let prevDecisionItemsParent: any[] = [];
		let isComponent: boolean = prevElement.type === "Component";
		if (isComponent)
			prevComponent = components[element.elementId];
		let typeId: number = component.ComponentType.ComponentTypeId;
		let previousPreviousElement = { ...element };
		let previousComponentBeforeLoop = { ...component };
		let previousPassedSubmissionOnBranch = { ...passedSubmissionOnBranch };
		let prevBranches: IDropdownOption[] = prevComponents[prevElement.componentId].Decision.Branches.map((condition, index) => {
			return { index: index, text: condition.Name || "Condition " + index, key: index };
		});
		let { addBranchOnly } = this.props;

		// mergeIconList tracks the number of mergeIcon encountered throughout this function
		let mergeIconList: any = [1];

		let prevLookupComponent: IComponent = { ...prevComponent };
		let parentDecisionID: string = { ...prevComponent }.Decision.ComponentId;

		// loop over each decision branches
		for (let i = 0; i < prevBranches.length + 1; i++) {

			prevComponent = prevLookupComponent;

			// Add '+' icon between decision component and its branches.
			if (i === 0) {
				decisionItems.push(
					<DecisionConfigContainer addOnly={true} addBranchOnly={addBranchOnly} componentId={parentDecisionID} toggleDecisionConfigDialog={this.props.toggleDecisionConfigDialog} />
				);
			}

			if (i > 0) {
				currentBranchLocation.pop();
			}

			// If it is the last branch in the decision, pop branchlist to start a new branch for the components starting outside of this decision
			if (i === prevBranches.length) {
				// prevDecisionItemsParent.push(
				// 	<DecisionConfigContainer addOnly={true} addBranchOnly={addBranchOnly} componentId={parentDecisionID} toggleDecisionConfigDialog={this.props.toggleDecisionConfigDialog} />
				// );
				// branchList.pop();
				let lastBranch: IUiBranch = branchList.pop();
				branchName = lastBranch.name;
				prevComponent = prevComponents[prevElement.componentId];

			} else {
				i === 0 ? mergeIconList.push(1) : mergeIconList;
				prevElement = previousPreviousElement;
				prevDecisionItems = [];
				let elementIndexInBranchSelector = 0;
				branchId = parts[0] + '_' + i.toString();
				prevBranchIndex = i;
				branchName = prevLookupComponent.Decision.Branches[branchIndex].Name;
				currentBranchLocation.push({ decisionId: component.Id, branchId: branchId });

				branchList.pop();
				branchList.push({
					id: branchId,
					index: prevBranchIndex,
					name: previousComponentBeforeLoop.Decision.Branches[prevBranchIndex].Name
				});

				// loop until the end/mergeicon is found. (MergeIcon marks the end of each branch in a decision.)
				while (prevElement.type !== "MergeIcon") {

					if (elementIndexInBranchSelector === 1) {
						let nextElementId = prevElement.componentId + "_" + i + "_ADD";
						if (this.getActiveElement(nextElementId)) {
							prevElement = this.getActiveElement(nextElementId);
							elementIndexInBranchSelector += 1;
						}
					}
					else {
						elementIndexInBranchSelector += 1;
					}

					let isComponent: boolean = prevElement.type === "Component";

					if (isComponent)
						prevComponent = components[prevElement.elementId];

					let typeId: number = prevComponent.ComponentType.ComponentTypeId;

					let passpreviousOutputBlocks: boolean = !isComponent
						? false
						: typeId === EComponentTypes.decision
						|| typeId === EComponentTypes.action
						|| typeId === EComponentTypes.block
						|| typeId === EComponentTypes.loop;

					let previousComponent: IComponent = prevElement.type === ACTIVE_ELEMENT_TYPES.MergeIcon ? components[prevElement.componentId] : prevComponent;
					let passedSubmissionOnCurrentBranch = previousPassedSubmissionOnBranch[currentBranchLocation[currentBranchLocation.length - 1].branchId];
					let index = i;
					let item: JSX.Element = this.getItem(previousComponent, prevElement, passpreviousOutputBlocks ? clone(previousOutputBlocks) : null, branchList,
						passedSubmissionOnCurrentBranch, branchName, index);

					let hideItem: boolean = false;
					if (prevElement.type === "Component" || prevElement.type === "Add") {
						let nextComponent = prevComponent && prevComponent.NextComponent ? components[prevComponent.NextComponent.ComponentId] : null;
						if (component) {
							hideItem =
								(prevElement.type === "Component" && prevComponent.Action && prevComponent.Action.ActionType &&
									prevComponent.Action.ActionType.NameType === 'Journey Information') ||
								(prevElement.type === "Add" && nextComponent && nextComponent.Action && nextComponent.Action.ActionType &&
									nextComponent.Action.ActionType.NameType === 'Journey Information')
								;
						}
					}
					if (!hideItem && item) {
						prevDecisionItems.push(item);
					}

					if (isComponent) {

						if (typeId === EComponentTypes.submission) {
							previousPassedSubmissionOnBranch[currentBranchLocation[currentBranchLocation.length - 1].branchId] = true;
						}

						if (typeId === EComponentTypes.block || typeId === EComponentTypes.action || typeId === EComponentTypes.sharedJourney)
							previousOutputBlocks[prevComponent.Id] = true;

					}

					prevElement = prevElement.nextElementId === null ? null : this.getActiveElement(prevElement.nextElementId);
					previousElementWasSummary = (isComponent && typeId === EComponentTypes.summary);

					// child decision component
					if (prevElement.type === "BranchSelector") {
						mergeIconList.push(1);

						parts = prevElement.nextElementId.split('_');
						branchId = parts[0] + '_' + parts[1];
						prevBranchIndex = +parts[1];
						branchName = prevComponent.Decision.Branches[prevBranchIndex].Name;

						currentBranchLocation.push({ decisionId: prevComponent.Id, branchId: branchId });

						branchList.push({
							id: branchId,
							index: prevBranchIndex,
							name: prevComponent.Decision.Branches[prevBranchIndex].Name
						});

						[prevElement, prevDecisionItems, previousPassedSubmissionOnBranch] = this.getDecisionItems(prevElement, prevBranches, previousElement, prevDecisionItems,
							branchId, prevBranchIndex, branchList, previousComponentBeforeLoop, parts, prevComponent, components,
							previousPassedSubmissionOnBranch, branchName, currentBranchLocation, previousOutputBlocks,
							previousElementWasSummary, decisionItemsParent);
					}

					// important: set the firstPrevElement to the next elementId of the first MergeIcon encountered in the for loop above.
					if (prevElement.type === "MergeIcon") {
						firstPrevElement = i === 0 ? prevElement.nextElementId === null ? null : this.getActiveElement(prevElement.nextElementId) : firstPrevElement;
						mergeIconList.pop();
					}

				}

				// Item for hamburger menu
				// Here, prevLookupComponent is used to prevent component being overridden when making chekcs for loading hamburger menu since the branch header is loaded only after all the child decision branches are loaded.
				let menu = this.getMenu(prevLookupComponent, prevLookupComponent.Id === this.props.StartId && branchId === 'root' && !this.props.parentComponentId, i);
				let contextMenu: JSX.Element = (this.state.showMenu && this.state.showMenuIndex === i &&
					this.state.editComponentId && this.state.editComponentId === prevLookupComponent.Id)
					// && this.state.editComponentId === component.Id && this.state.editIndex === i
					&& <ContextualMenu target={'.branch-' + component.Id + '_branch_' + i}
						shouldFocusOnMount={false}
						onDismiss={() => {
							this.changeShowMenu(true, i)
						}}
						directionalHint={DirectionalHint.bottomRightEdge}
						items={menu}
						isBeakVisible={true}
						beakWidth={15} />;

				// Collapsible child decision branch
				// prevDecisionItemsParent.push(<CollapseContent
				// 	component={prevLookupComponent}
				// 	saveEditedBranch={this.saveEditedBranch}
				// 	changeEditComponentId={this.changeEditComponentId}
				// 	nameChange={this.nameChange}
				// 	deleteBranch={this.props.deleteBranch}
				// 	decisionItems={prevDecisionItems}
				// 	parentDecisionID={parentDecisionID}
				// 	toggleDecisionConfigDialog={this.props.toggleDecisionConfigDialog}
				// 	index={i}
				// 	contextMenu={contextMenu}
				// 	toggleShowMenu={this.changeShowMenu}
				// 	showMenu={this.state.showMenu}
				// 	editComponentId={this.state.editComponentId}
				// 	editIndex={this.state.editIndex}
				// 	previousOutputBlocks={previousOutputBlocks}
				// />);

				let collapsibleItem: JSX.Element = this.getItem(prevLookupComponent, prevElement, previousOutputBlocks, branchList,
					null, branchName, null, true, prevDecisionItems, parentDecisionID, i, contextMenu);
				prevDecisionItemsParent.push(collapsibleItem);

			}
		}
		decisionItems.push(<div className="conditions component ">{prevDecisionItemsParent}</div>);

		if (prevElement.type === ACTIVE_ELEMENT_TYPES.MergeIcon) {
			currentBranchLocation.pop();

			let passpreviousOutputBlocks: boolean = !isComponent
				? false
				: typeId === EComponentTypes.decision
				|| typeId === EComponentTypes.action
				|| typeId === EComponentTypes.block
				|| typeId === EComponentTypes.loop;

			let previousComponent: IComponent = prevElement.type === ACTIVE_ELEMENT_TYPES.MergeIcon ? prevComponents[prevElement.componentId] : prevComponent;
			let passedSubmissionOnCurrentBranch = previousPassedSubmissionOnBranch[currentBranchLocation[currentBranchLocation.length - 1].branchId];

			let item: JSX.Element = this.getItem(previousComponent, prevElement, passpreviousOutputBlocks ? clone(previousOutputBlocks) : null, branchList,
				passedSubmissionOnCurrentBranch, branchName);

			//hide item if it is the Journey Information action Component, or if it is the add component button that comes after the first step
			let hideItem: boolean = false;

			if (prevElement.type === "Component" || prevElement.type === "Add") {
				let nextComponent = prevComponent && prevComponent.NextComponent ? prevComponents[prevComponent.NextComponent.ComponentId] : null;
				if (prevComponent) {
					hideItem =
						//TODO: update this to use a property that indicates that a component is a system component when that property becomes available
						(prevElement.type === "Component" && prevComponent.Action && prevComponent.Action.ActionType &&
							prevComponent.Action.ActionType.NameType === 'Journey Information') ||
						(prevElement.type === "Add" && nextComponent && nextComponent.Action && nextComponent.Action.ActionType &&
							nextComponent.Action.ActionType.NameType === 'Journey Information')
						;
				}
			}

			if (!hideItem && item) {
				decisionItems.push(item);
			}

			if (isComponent) {

				if (typeId === EComponentTypes.submission) {
					previousPassedSubmissionOnBranch[currentBranchLocation[currentBranchLocation.length - 1].branchId] = true;
				}

				if (typeId === EComponentTypes.block || typeId === EComponentTypes.action || typeId === EComponentTypes.sharedJourney)
					previousOutputBlocks[prevComponent.Id] = true;

			}

			previousElementWasSummary = (isComponent && typeId === EComponentTypes.summary);

		}

		// set element in order to get the next approriate element in the parent loop 
		element = firstPrevElement;
		return [element, decisionItems, previousPassedSubmissionOnBranch];

	}

}



// WEBPACK FOOTER //
// ./source/ts/components/components/component-list.tsx